import { AxiosInstance } from 'axios';
import { ProjectOverviewSnapshotDetail, ProjectOverviewSnapshotListItem } from '../../types';

export function createProjectOverviewSnapshotApi(client: AxiosInstance) {
  return {
    async getProjectOverviewSnapshots(projectId: number) {
      const r = await client.get(`/projects/${projectId}/overview-snapshots`);
      return r.data as ProjectOverviewSnapshotListItem[];
    },
    async getProjectOverviewSnapshot(projectId: number, snapshotId: number) {
      const r = await client.get(`/projects/${projectId}/overview-snapshots/${snapshotId}`);
      return r.data as ProjectOverviewSnapshotDetail;
    },
    async createProjectOverviewSnapshot(projectId: number) {
      const r = await client.post(`/projects/${projectId}/overview-snapshots`);
      return r.data as ProjectOverviewSnapshotDetail;
    },
    async createAllProjectOverviewSnapshots() {
      const r = await client.post('/projects/overview-snapshots/bulk');
      return r.data as { attempted: number; captured: number; failed_project_ids: number[] };
    },
  };
}

export type ProjectOverviewSnapshotApi = ReturnType<typeof createProjectOverviewSnapshotApi>;
